import { inject, Injectable } from '@angular/core';
import { UserSuggested } from '@models';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';
import { ClubManagerService } from './club-manager.service';
import { Observable, combineLatest, map, shareReplay, switchMap } from 'rxjs';
import { orderBy } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class SuggestedUsersService {
  private readonly firestore = inject(FirestoreService);
  private readonly tenantContext = inject(TenantContextService);
  private readonly clubManagerService = inject(ClubManagerService);

  public suggestedUsers$ = this.tenantContext.tenantId$.pipe(
    switchMap(() =>
      this.firestore.listDocuments<UserSuggested>(
        this.tenantContext.collections.SUGGESTED_USERS,
        orderBy('name', 'asc'),
      ),
    ),
    shareReplay(1),
  );

  public clubSuggestedUsers$: Observable<UserSuggested[]> = combineLatest([
    this.suggestedUsers$,
    this.clubManagerService.club$,
  ]).pipe(
    map(([users, club]) => {
      return club ? users.filter((user) => user.clubId === club.id) : [];
    }),
    shareReplay(1),
  );

  delete(user: UserSuggested) {
    return this.firestore.deleteForever(this.tenantContext.collections.SUGGESTED_USERS, user.id);
  }
}
